<template>
  <div class="mh-page">
    <AppHeader title="My Profile" back />
    <main class="mh-content">
      <AppShimmer v-if="loading" type="profile" :count="5" /><template v-else>
        <section class="profile-card">
          <div class="avatar">{{ initial }}</div>
          <div>
            <h1>{{ user.name || "MH13 User" }}</h1>
            <p>+91 {{ user.mobile || "" }}</p><small><i class="bi bi-geo-alt"></i> Solapur, Maharashtra</small>
          </div>
        </section>
        <div class="stats">
          <div><strong>{{ posts.length }}</strong><span>My Posts</span></div>
          <div><strong>{{ approved }}</strong><span>Approved</span></div>
          <div><strong>{{ saved.length }}</strong><span>Saved</span></div>
        </div>
        <nav class="menu mh-card"><button v-for="entry in menu" :key="entry.key" :class="{ active: section === entry.key }"
            @click="section = entry.key"><i :class="entry.icon"></i><span>{{ entry.label }}</span><b
              v-if="entry.key === 'notifications' && unread">{{ unread }}</b><i
              class="bi bi-chevron-right"></i></button><button @click="logout"><i
              class="bi bi-box-arrow-right"></i><span>Logout</span><i class="bi bi-chevron-right"></i></button></nav>
        <section v-if="section === 'posts'" class="mh-section">
          <div class="mh-section-head">
            <h2 class="mh-section-title">My Posts</h2>
            <div><button v-for="name in tabs" :key="name" :class="['tab', { active: tab === name }]"
                @click="tab = name">{{ name }}</button></div>
          </div>
          <div class="post-list">
            <div v-for="post in filtered" :key="post.type + '-' + post.item.id" class="mh-card post">
              <div><strong>{{ post.item.name || post.item.title }}</strong><small>{{ post.type }} ·
                  {{ post.item.iddate }}</small></div>
              <StatusBadge :value="post.item.status || 'Pending'" />
            </div>
          </div>
          <EmptyState v-if="!filtered.length" title="No posts found" />
        </section>
        <section v-if="section === 'saved'" class="mh-section">
          <h2 class="mh-section-title">Saved Listings</h2>
          <div class="listing-list">
            <ListingCard v-for="item in saved" :key="item.type + '-' + item.id" :item="item" :type="item.type"
              @open="openListing" />
          </div>
          <EmptyState v-if="!saved.length" title="Nothing saved yet"
            message="Tap the bookmark on a listing to keep it here." />
        </section>
        <section v-if="section === 'notifications'" class="mh-section">
          <h2 class="mh-section-title">Notifications</h2>
          <div class="notice-list"><button v-for="notice in notifications" :key="notice.id"
              :class="['mh-card', 'notice', { unread: !Number(notice.is_read) }]" @click="readNotice(notice)"><i
                class="bi bi-bell"></i><span><strong>{{ notice.title }}</strong><small>{{ notice.message }}</small></span></button>
          </div>
          <EmptyState v-if="!notifications.length" title="You're all caught up" />
        </section>
        <section v-if="section === 'settings'" class="mh-section">
          <h2 class="mh-section-title">Settings</h2>
          <div class="mh-card settings"><label class="mh-form-label">Full name</label><input
              v-model.trim="settings.name" class="mh-form-control"><label class="mh-form-label">Date of
              birth</label><input v-model="settings.dob" type="date" class="mh-form-control"><button
              class="mh-btn mh-btn-primary" @click="saveSettings">Save profile</button><label class="switch"><span>Push
                notifications</span><input v-model="preferences.notifications" type="checkbox"
                @change="savePreferences"></label><button class="clear" @click="clearCache">Clear local cache</button>
          </div>
        </section>
      </template>
    </main>
    <BottomNavigation />
  </div>
</template>
<script>
import api from "@/api"; import AppHeader from "@/components/AppHeader.vue"; import BottomNavigation from "@/components/BottomNavigation.vue"; import StatusBadge from "@/components/StatusBadge.vue"; import EmptyState from "@/components/EmptyState.vue"; import AppShimmer from "@/components/AppShimmer.vue"; import ListingCard from "@/components/ListingCard.vue";
export default { name: "ProfileView", components: { AppHeader, BottomNavigation, StatusBadge, EmptyState, AppShimmer, ListingCard }, data() { return { loading: true, user: {}, groups: {}, saved: [], notifications: [], section: this.$route.query.section || "posts", tab: "All", tabs: ["All", "Pending", "Approved", "Rejected"], settings: { name: "", dob: "" }, preferences: { notifications: localStorage.getItem("profile_notifications") !== "false" }, menu: [{ key: "posts", label: "My Posts", icon: "bi bi-file-post" }, { key: "saved", label: "Saved Listings", icon: "bi bi-bookmark" }, { key: "notifications", label: "Notifications", icon: "bi bi-bell" }, { key: "settings", label: "Settings", icon: "bi bi-gear" }] } }, computed: { initial() { return (this.user.name || "M").charAt(0).toUpperCase() }, posts() { return Object.entries(this.groups).flatMap(([type, items]) => (items || []).map(item => ({ type, item }))) }, approved() { return this.posts.filter(x => ["Approved", "Accepted"].includes(x.item.status)).length }, filtered() { if (this.tab === "All") return this.posts; return this.posts.filter(x => (x.item.status || "Pending").toLowerCase() === this.tab.toLowerCase()) }, unread() { return this.notifications.filter(x => !Number(x.is_read)).length } }, async mounted() { if (!localStorage.getItem("token")) return this.$router.replace("/login"); try { const [profile, features] = await Promise.all([api.getProfile(), api.getProfileFeatures()]); this.user = profile.data?.profile?.[0] || profile.data?.profile || {}; this.groups = { food: profile.data?.food, event: profile.data?.event, news: profile.data?.news, business: profile.data?.business, property: profile.data?.property, job: profile.data?.job }; this.saved = features.data?.saved || []; this.notifications = features.data?.notifications || []; this.settings = { name: this.user.name || "", dob: this.user.dob || "" }; if (!this.user.name || !this.user.dob || !this.user.terms_accepted_at) return this.$router.replace({ path: "/complete-profile", query: { next: "/profile" } }) } finally { this.loading = false } }, methods: { openListing(item) { this.$router.push({ path: "/details", query: { id: item.id, name: item.type } }) }, async readNotice(notice) { if (!Number(notice.is_read)) { await api.markNotificationRead(notice.id); notice.is_read = 1 } }, async saveSettings() { if (this.settings.name.length < 2 || !this.settings.dob) return this.$alert("Name and date of birth are required.", "warning"); await api.completeProfile({ ...this.settings, terms_accepted: true }); this.user = { ...this.user, ...this.settings }; this.$alert("Profile updated", "success") }, savePreferences() { localStorage.setItem("profile_notifications", String(this.preferences.notifications)); this.$alert("Preference saved", "success") }, clearCache() { Object.keys(localStorage).filter(k => k.startsWith("home_") || k.includes("recent")).forEach(k => localStorage.removeItem(k)); this.$alert("Local cache cleared", "success") }, async logout() { if (await this.$confirm({ title: "Logout?", message: "You can log in again using OTP.", confirmText: "Logout" })) { localStorage.removeItem("token"); this.$router.push("/") } } } };
</script>
<style
  scoped>
  .profile-card {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 24px 18px;
    border-radius: 18px;
    background: linear-gradient(135deg, #3e0a82, #7434cf);
    color: #fff
  }

  .avatar {
    width: 70px;
    height: 70px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #ffc400;
    color: #172033;
    font-size: 30px;
    font-weight: 900
  }

  .profile-card h1 {
    margin: 0;
    font-size: 20px
  }

  .profile-card p {
    margin: 4px 0
  }

  .stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 18px 0
  }

  .stats div {
    text-align: center
  }

  .stats strong,
  .stats span {
    display: block
  }

  .stats span {
    font-size: 11px;
    color: #667085
  }

  .menu {
    overflow: hidden
  }

  .menu button {
    width: 100%;
    height: 54px;
    display: flex;
    align-items: center;
    gap: 12px;
    border: 0;
    border-bottom: 1px solid #edf0f4;
    background: #fff;
    padding: 0 16px;
    font-size: 17px
  }

  .menu button.active {
    background: #faf7ff;
    color: #5b18b7
  }

  .menu button span {
    flex: 1;
    text-align: left;
    font-size: 14px;
    font-weight: 700
  }

  .menu b {
    min-width: 22px;
    padding: 3px;
    border-radius: 12px;
    background: #e31b54;
    color: #fff;
    font-size: 10px
  }

  .tab {
    border: 0;
    background: transparent;
    font-size: 10px;
    padding: 5px
  }

  .tab.active {
    color: #5b18b7;
    font-weight: 900
  }

  .post-list,
  .listing-list,
  .notice-list {
    display: grid;
    gap: 9px;
    margin-top: 12px
  }

  .post {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px
  }

  .post strong,
  .post small,
  .notice strong,
  .notice small {
    display: block
  }

  .post small,
  .notice small {
    color: #667085;
    margin-top: 4px
  }

  .notice {
    width: 100%;
    display: flex;
    gap: 12px;
    text-align: left;
    padding: 14px;
    border: 0
  }

  .notice.unread {
    border-left: 4px solid #5b18b7
  }

  .settings {
    padding: 18px;
    margin-top: 12px
  }

  .settings .mh-btn {
    width: 100%;
    margin: 16px 0
  }

  .switch {
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
    border-top: 1px solid #edf0f4
  }

  .clear {
    width: 100%;
    border: 0;
    background: #fff0f0;
    color: #b42318;
    padding: 12px;
    border-radius: 9px
  }
</style>
